// Lapisan per-frame di atas dunia: ghost/hover editor & HUD jam kota.
import { phaseLabel } from "./trafficCore";

// Ghost & hover editor — digambar tiap frame di atas dunia
export function drawOverlay(ctx, gridToScreen, GRID_SIZE, opts) {
  // Ghost footprint preview (mode bangun/pindah): hijau = lahan bebas, merah = tabrakan
  if (opts.ghost) {
    const { x, y, w, h, valid } = opts.ghost;
    const T = gridToScreen(x, y), R = gridToScreen(x + w, y), B = gridToScreen(x + w, y + h), L = gridToScreen(x, y + h);
    ctx.fillStyle = valid ? "rgba(34,197,94,0.35)" : "rgba(239,68,68,0.35)";
    ctx.strokeStyle = valid ? "rgba(34,197,94,0.95)" : "rgba(239,68,68,0.95)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(...T); ctx.lineTo(...R); ctx.lineTo(...B); ctx.lineTo(...L);
    ctx.closePath();
    ctx.fill();
    ctx.stroke();
  }

  // Highlight hover (mode editor) — untuk jalan/sungai/hapus (pakai sudut tile asli)
  if (opts.hover && !opts.ghost) {
    const [hx, hy] = opts.hover;
    if (hx >= 0 && hy >= 0 && hx < GRID_SIZE && hy < GRID_SIZE) {
      const T = gridToScreen(hx, hy), R = gridToScreen(hx + 1, hy), B = gridToScreen(hx + 1, hy + 1), L = gridToScreen(hx, hy + 1);
      ctx.strokeStyle = opts.erase ? "rgba(220,60,50,0.9)" : "rgba(255,220,80,0.9)";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(...T); ctx.lineTo(...R); ctx.lineTo(...B); ctx.lineTo(...L);
      ctx.closePath();
      ctx.stroke();
    }
  }
}

// HUD jam kota (pil kecil di kiri-atas kanvas): jam simulasi + fase hari (jam sibuk/sepi)
export function drawCityClock(ctx, hour) {
  const hh = Math.floor(hour), mm = Math.floor((hour - hh) * 60);
  const txt = `${String(hh).padStart(2, "0")}:${String(mm).padStart(2, "0")}  ·  ${phaseLabel(hour)}`;
  ctx.save();
  ctx.font = "600 12px 'Inter', system-ui, sans-serif";
  const w = ctx.measureText(txt).width + 34, h = 26, x = 14, y = 14;
  ctx.fillStyle = "rgba(20,24,32,0.72)";
  ctx.beginPath(); ctx.roundRect(x, y, w, h, 13); ctx.fill();
  // ikon jam sederhana
  const cx = x + 15, cy = y + h / 2, r = 6;
  ctx.strokeStyle = "rgba(255,255,255,0.9)"; ctx.lineWidth = 1.4;
  ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.stroke();
  const a = (hour % 12) / 12 * Math.PI * 2 - Math.PI / 2, b = (hour % 1) * Math.PI * 2 - Math.PI / 2;
  ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(a) * r * 0.55, cy + Math.sin(a) * r * 0.55); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(cx, cy); ctx.lineTo(cx + Math.cos(b) * r * 0.85, cy + Math.sin(b) * r * 0.85); ctx.stroke();
  ctx.fillStyle = "rgba(255,255,255,0.95)";
  ctx.textBaseline = "middle";
  ctx.fillText(txt, x + 28, cy + 0.5);
  ctx.restore();
}
